<template>
  <table class="table table-bordered bg-white table-sm my-3 shadow">
    <tbody>
      <tr>
        <td>
          {{ $t("Ofício ID") }}:<b>{{ oficio.id }}</b>
        </td>
        <td>
          {{ $t("Número") }}:<b>{{ oficio.numero }}/{{ oficio.ano }}</b>
        </td>
        <td>
          Criado:<b>{{ oficio.cadastrado }}</b>
        </td>
        <td>
          Atualizado:<b>{{ oficio.atualizado }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Técnico responsável: <b>{{ oficio.tecnico }}</b> <span class="badge"> {{ oficio.tecnico_full.profissao ? oficio.tecnico_full.profissao : 'Não informado'  }}</span>
        </td>
        <td>
          Unidade:
          <b v-if="oficio.unidade">{{ oficio.unidade.nome }}</b>
        </td>
        <td>
          Status:
          <b v-if="oficio.unidade" v-html="oficio.status_nome"></b>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          Técnicos participantes: 
          <span v-for="tecnico in oficio.tecnicos" :key="tecnico.nome" class="badge text-bg-secondary">
            <b>{{ tecnico.nome | toUpper }}</b>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    props: ["oficio"],
  };
</script>
